


import React, { useEffect, useRef, useState } from "react";
import "./embeded-vr360.scss";
import * as apiConfig from "../../../api/api-config";

function IframeVR360(props) {
	const iframeRef = useRef(null);
	const [iframeHeight, setIframeHeight] = useState(0);

	function calIframeHeight() {
        var headerHeight = document.getElementById('header-map-page-container').offsetHeight;
        var windowHeight = window.innerHeight;

        setIframeHeight((windowHeight - headerHeight) + 'px');
    }

	useEffect(()=>{
	    calIframeHeight();
	}, [])

	function scrollDown () {
		window.scrollBy({
			top: window.innerHeight,
			behavior: 'smooth',
		});
	}

	return (
		<div style={{position: 'relative'}}>
			<iframe
				className="iframe-bdsh"
				// 
				src={apiConfig.IframeUrl}
				allowFullScreen
				style={{
					width: '100%',
					height: iframeHeight,
					zIndex: '100',
				}}
				title="vr360 bai da song hong"
				width="100%" height="100%"
			/>
			
			<div id="scroll_prompt_button" onClick={scrollDown}>
				<p><span></span></p>
			</div>
		</div>
	);
}
export default  IframeVR360;
